module.exports = __webpack_public_path__ + "static/media/grosdodo.15b52639.gif";